import Action from "./class.Action";

export default class ClearSticky extends Action {
	constructor(options) {
		super(options);
		this.clear();
	}

	async clear() {
		await this.mainView.collapseThenUnsticky();
		this.onAdvance(this.$anchor);
	}
}
